var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8375 9.77128C4.69188 10.1613 4.56875 10.5213 4.45875 10.8857C5.05875 10.45 5.77188 10.1738 6.595 10.0707C8.16563 9.8744 9.56125 8.83753 10.2675 7.5344L9.3575 6.62503L10.2406 5.74065L10.8656 5.11503C11.1344 4.84628 11.4375 4.35003 11.7581 3.63503C8.2625 4.1769 6.12188 6.31753 4.83688 9.77128H4.8375ZM11.125 6.6244L11.75 7.24878C11.125 9.12378 9.25 10.9988 6.75 11.3113C5.08188 11.52 4.04 12.6657 3.62375 14.7488H2.375C3 10.9988 4.25 2.24878 13.625 2.24878C13 4.1219 12.3763 5.37128 11.7519 5.9969L11.125 6.6244Z",
    fill: "url(#paint0_linear_443_46957)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_443_46957",
    x1: 8,
    y1: 14.7488,
    x2: 8,
    y2: 2.24878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeIcon);
export default __webpack_public_path__ + "static/media/typeIcon.52df525e03650273146c1682183905e5.svg";
export { ForwardRef as ReactComponent };